import { CaseProjectionWithIndexes } from '../../CaseProjection';
import { letterFromIndex } from '../../../../../utils/letterFromIndex';

export const getCaseLabel = (caseProjectionWithIndexes: CaseProjectionWithIndexes): string =>
  caseProjectionWithIndexes.buildingIndex +
  1 +
  letterFromIndex(caseProjectionWithIndexes.indexInBuilding);
